/**
 * HD wallet derivation paths.
 *
 * ZcashWallet is ZEC-only. We keep BIP-44 coin-type 133 as the
 * transparent-receiver root; the shielded UFVK is derived elsewhere
 * via ZIP-32 inside the @chainsafe/webzjs-keys WASM module.
 */

export const PATHS = {
  /** Zcash transparent — t1… (BIP-44 coin type 133). */
  zcash: "m/44'/133'/0'/0/0",
} as const;

export type SupportedChain = keyof typeof PATHS;
